module.exports = __webpack_public_path__ + "static/media/USRSB_Original_Logo_4C.d5e8f5e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/USRSB_Original_Logo_4C.png
// module id = 856
// module chunks = 0